const styles = (theme) => ({
    pageTitle: {
        marginTop: '30px',
        fontSize: '30px',
    },
});

export default styles;
